/* -------------------------------------------------------------------------- *
 * Filter Forms *
 * -------------------------------------------------------------------------- */

const settings = {
    selector: '.js-filter',
};

function submitForm(input_el) {
    const form = input_el.form;
    form.submit();
}

/* ------------- *
 * Module Export *
 * ------------- */

const Filter = {
    init(selector = settings.selector) {
        const inputs = document.querySelectorAll(selector);
        const inputs_arr = Array.from(inputs);
        inputs_arr.forEach((input_el) => {
            input_el.addEventListener('change', () => submitForm(input_el));
        });
    },
};

export default Filter;
